import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import Provisions from './Provisions';
import Toggle from './Toggle';

const ProvisionList = ({
  numbers,
  companies,
  gateways,
  filterEmails,
  onUserTypeSelect,
  companySearchFilter,
  onToggleChange,
  sameForAll,
  onOrder,
  orderedNumbers,
  provider,
  setProvider
}) => {
  const [showUser, setShowUser] = useState(false);
  const companySelected = (index, value) => {
    setShowUser(value)
  }

  return (
    <div className="provisionList-container">
      <div className="forAllToggle">
        <h6 style={{ marginRight: '10px', marginBottom: '0px' }}>Same for all: </h6>
        <Toggle value={sameForAll} onToggle={onToggleChange} />
      </div>
      <div className="table-header-fixed provision-table">
        <table className="provisionList">
          <thead>
            <tr>
              <th>Number</th>
              <th>SMS/MMS</th>
              <th>Route</th>
              <th>Company</th>
              <th>User/Edge Device</th>
              <th style={{ width: '100px' }}>Temp DID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {numbers.length ? (
              numbers.map((num, idx) => (
                <Provisions
                  orderedNumbers={orderedNumbers}
                  key={idx}
                  telephoneNumber={num}
                  index={idx}
                  isDisabled={sameForAll}
                  companies={companies}
                  gateways={gateways}
                  filterEmails={filterEmails}
                  onUserTypeSelect={onUserTypeSelect}
                  companySearchFilter={companySearchFilter}
                  onOrder={onOrder}
                  provider={provider}
                  companySelected={companySelected}
                />
              ))
            ) : (
              <tr>
                <td colSpan={12}>
                  <Alert rowSpan={12} color="info">
                    Please Select Number
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(ProvisionList);
